import { Injectable } from "@angular/core";
import { EMPTY, Observable } from "rxjs";
import {
	GetStakeableDataByIdGQLService,
	GetStakeableDataByIdQuery
} from "../../../../api/graphql/staking/generated/staking.stakeable-info-by-id.service.graphql-gen";
import { catchError, map } from "rxjs/operators";
import { ExceptionsService } from "@core-services/exceptions.service";
import { InfoService } from "@core-services/info.service";
import { GetStakingFilteredAssetsGQLService } from "@gql/staking";

@Injectable({
	providedIn: "root"
})
export class StakingAdpRemote {
	public constructor(
		private readonly stakeableByIdService: GetStakeableDataByIdGQLService,
		private readonly stakingFilteredAssetsService: GetStakingFilteredAssetsGQLService,
		private readonly exceptionsService: ExceptionsService,
		private readonly infoService: InfoService
	) {}

	public fetchStakeableInfo(stakeableId: string): Observable<GetStakeableDataByIdQuery> {
		return this.stakeableByIdService
			.watch({ filter: { or: [{ assetId: { equals: stakeableId } }] } }, { fetchPolicy: "network-only" })
			.valueChanges.pipe(
				map(({ data }) => data),
				catchError(this.exceptionsService.extractGqlErrorAndRethrow),
				catchError((error) => {
					this.infoService.handleApiError(error);
					return EMPTY;
				})
			);
	}

	public getStakeableAssets(): Observable<GetStakeableDataByIdQuery> {
		return this.stakeableByIdService
			.fetch({ filter: { or: [{ enabled: { equals: true } }] } }, { fetchPolicy: "network-only" })
			.pipe(
				map(({ data }) => data),
				catchError(this.exceptionsService.extractGqlErrorAndRethrow),
				catchError((error) => {
					this.infoService.handleApiError(error);
					return EMPTY;
				})
			);
	}
}
